import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import {
  createWeb3Modal,
  defaultConfig,
  useWeb3Modal,
  useWeb3ModalProvider,
  useWeb3ModalAccount,
  useDisconnect,
} from "@web3modal/ethers/react";
import CopyToClipboard from "react-copy-to-clipboard";
import { projectId } from "../../../config/BackendUrl";
import { useDispatch } from 'react-redux';
import { BrowserProvider } from 'ethers';
import { setValue } from '../../../Store/store';
import { getUserByAddress } from '../../../hooks/User';
import { DefaultProfile, headerAvatar } from '../../../assets/img';
import { MdContentCopy, MdCreate } from "react-icons/md";
import { CgProfile } from 'react-icons/cg';
import { BiHeart, BiLogOutCircle } from 'react-icons/bi';
import { BsGrid3X3 } from 'react-icons/bs';
import { AiFillSetting } from 'react-icons/ai';

const Menu = [
  {
    title: ' Home',
    link: '/home',
  },
  {
    title: 'Marketplace',
    link: 'Marketplace',
  },
  {
    title: 'Collections',
    link: 'Collections',
  },
  {
    title: 'Profile',
    link: 'Profile',
  },

  {
    title: 'Launchpad',
    link: 'Launchpad',
  },
  {
    title: "Docs",
    link: "docs",
  },
  {
    title: 'Create',
    link: 'Create',
  },

];

const HomesMenu = [
  {
    icon: 'home-smile-2',
    title: 'NFT',
    link: '/upload',
  },
  {
    icon: 'home-2',
    title: 'Collection',
    link: '/collectionAdd',
  },
  {
    icon: 'home-3',
    title: 'Air Droping',
    link: '/drop',
  },
  {
    icon: 'more-2',
    title: 'Auction',
    link: '/auction',
  },

];
const mainnet = {
  chainId: 1,
  name: "Ethereum",
  currency: "ETH",
  explorerUrl: "https://etherscan.io",
  rpcUrl: "https://cloudflare-eth.com",
};

const sepolia = {
  chainId: 11155111,
  name: "Sepolia test network",
  currency: "SepoliaETH",
  explorerUrl: "https://sepolia.etherscan.io",
  rpcUrl: "https://sepolia.infura.io/v3/b8d48fc740104848a6133989ffafe35f",
};

const Linea = {
  chainId: 59140,
  name: "Linea Goerli test network",
  currency: "LineaETH",
  explorerUrl: "https://goerli.lineascan.build",
  rpcUrl: "https://linea-goerli.infura.io/v3/b8d48fc740104848a6133989ffafe35f",
};

const metadata = {
  name: "My Website",
  description: "My Website description",
  icons: [
    "https://dtoc.infura-ipfs.io/ipfs/QmPdw6iGVsaQekMqdhCKzDLVCVPJ5N6HTAi4Eg2B6E6uc5",
  ],
};

const ethersConfig = defaultConfig({
  metadata,
  // enableEIP6963: true, // true by default
  // enableInjected: true, // true by default
  // enableCoinbase: true, // true by default
  // rpcUrl: 'https://sepolia.infura.io/v3/', // used for the Sepholia SDK
  // defaultChainId: 1, // used for the Sepholia SDK
});

createWeb3Modal({
  ethersConfig,
  chains: [mainnet, sepolia, Linea],
  // chains: [mainnet],
  projectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
});
function MobileMenu() {
  const { open } = useWeb3Modal();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const codeSnippet = localStorage.getItem("WalletAddress");
  const codeSnippets = localStorage.getItem("WalletBalance");
  const handleOpen = () => setOpen(true);
  const [opens, setOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isActive, setActive] = useState(false);
  const [user, setUser] = useState(null);
  const [link, setLink] = useState(null);
  const { disconnect } = useDisconnect(); // Hook to disconnect the wallet

  const route = useNavigate();
  const redirect = (url) => {
    route(url);
    // window.location.replace(`${url}`)
  };

  const dispatch = useDispatch();
  const { walletProvider } = useWeb3ModalProvider();

  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };
  
  const navigate = useNavigate();
  
  const handleGoAnotherpage = (prp) => {
    if (prp === "/logout") {
      handleDisconnect()
      localStorage.removeItem("WalletAddress");
      localStorage.removeItem("WalletBalance");
      localStorage.removeItem("UserId");
      setUser(null);
      navigate("/", { replace: true }); // Update the route
      window.location.reload(); // Reload the page
    } 
    else {
      setLink(prp);
      codeSnippet !== null ? redirect(prp) : handleOpen();
    }
  };
  
  const handleDisconnect = () => {
    disconnect(); // Disconnects the wallet
  };

  useEffect(() => {
    if (isConnected) {
      localStorage.setItem("WalletAddress", address);
      localStorage.setItem("chainId", chainId);
      const provider = new BrowserProvider(walletProvider)
      dispatch(setValue(provider));
      // dispatch(setValue({ wallet: address, provider: provider }));

      getUserByAddress(address).then((data) => {
        if (data.status === 200) {
          localStorage.setItem("userId", data.user._id);

        }
      })
    }
    else {
      localStorage.removeItem("WalletAddress");
      localStorage.removeItem("chainId");
    }
  }, [isConnected])



    const profileArr = [
      { title: "My Profile", icon: <CgProfile size={21} />, link: "/profile" },
      // { title: "Favorites", icon: <BiHeart size={21} />, link: "/" },
      {
        title: "My Collections",
        icon: <BsGrid3X3 size={20} />,
        link: "/collections",
      },
      { title: "Create", icon: <MdCreate size={21} />, link: "/mint" },
      // { title: "Settings", icon: <AiFillSetting size={21} />, link: "/settings" },
      { title: "Logout", icon: <BiLogOutCircle size={21} />, link: "/logout" },
    ];
    
  return (
    <div>
      <div className="header__mobile__menu space-y-40">
      <div className="mx-3 avatar-popup" >
            <div className="Resource_main_class">
              {user === null ?
                <img
                  className="avatar_org rounded-circle"
                  style={{ width: "2.5rem", height: "2.5rem" }}
                  src={DefaultProfile}
                  alt="avatar"
                />
                :
                <img
                  className="avatar_org rounded-circle"
                  style={{ width: "2.5rem", height: "2.5rem" }}
                  src={user.profilePicture ? user.profilePicture : DefaultProfile}
                  alt="avatar"
                />
              }
            </div>
            <div
              className="Resource_dropdown_class"
              style={{ marginLeft: "-6%" }}
            >
              <div className="avatar_popup avatar_Toggl1 p-3" id="dfsa">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="p4">
                    {" "}
                    {codeSnippet === null
                      ? `Wallet Address`
                      : `${codeSnippet.slice(0, 5)}...${codeSnippet.slice(
                        -5
                      )}`}
                  </span>

                  <CopyToClipboard
                    text={codeSnippet}
                    onCopy={onCopyText}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="p3 ms-2">
                      {isCopied ? (
                        "Copied!"
                      ) : (
                        <MdContentCopy className="icons__size1" />
                      )}
                    </span>
                  </CopyToClipboard>
                </div>
                <div
                  className="d-flex align-items-center py-2"
                  style={{ marginTop: "-0.2rem" }}
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 36 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse
                      cx="17.6725"
                      cy="17.549"
                      rx="17.6725"
                      ry="17.549"
                      fill="url(#paint0_radial)"
                    />
                    <g clipPath="url(#clip0)">
                      <path
                        d="M17.8464 5.91772L17.6917 6.43055V21.3116L17.8464 21.4623L24.9309 17.3792L17.8464 5.91772Z"
                        fill="white"
                        fill-opacity="0.42"
                      />
                      <path
                        d="M17.8465 5.91772L10.762 17.3792L17.8465 21.4623V14.2395V5.91772Z"
                        fill="white"
                        fill-opacity="0.82"
                      />
                      <path
                        d="M17.8465 22.7702L17.7593 22.8739V28.1749L17.8465 28.4232L24.9353 18.6892L17.8465 22.7702Z"
                        fill="white"
                        fill-opacity="0.85"
                      />
                      <path
                        d="M17.8465 28.4231V22.7701L10.762 18.6891L17.8465 28.4231Z"
                        fill="white"
                        fill-opacity="0.47"
                      />
                      <path
                        d="M17.8464 21.4622L24.9309 17.3792L17.8464 14.2395V21.4622Z"
                        fill="white"
                        fill-opacity="0.63"
                      />
                      <path
                        d="M10.762 17.3791L17.8464 21.4622V14.2394L10.762 17.3791Z"
                        fill="white"
                      />
                    </g>
                    <defs>

                      <radialGradient
                        id="paint0_radial"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(18.7772) rotate(91.8025) scale(35.1156 35.3624)"
                      >
                        <stop stop-color="#31E7FA" />
                        <stop offset="0.526042" stop-color="#4477FF" />
                        <stop offset="1" stop-color="#DB74FF" />
                      </radialGradient>
                      <clipPath id="clip0">
                        <rect
                          width="14.1733"
                          height="22.5105"
                          fill="white"
                          transform="translate(10.762 5.91772)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <h5 className="w-full align-items-center text-sm mx-2 font-bold text-green-500">
                    {codeSnippets !== null && codeSnippets !== undefined
                      ? `${parseFloat(codeSnippets.slice(0, 9)).toFixed(
                        4
                      )} ETH`
                      : "0.000 ETH"}
                  </h5>
                </div>
                <div className="d-flex flex-column">
                  {profileArr.map((data) => (
                    <>

                      <div
                        className="d-flex text-dark align-item-center text-sm py-1 link"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleGoAnotherpage(`${data.link}`)
                        }
                      >
                        <div className="d-flex align-items-center ">
                          <div className="mr-2">{data.icon}</div>
                          <div style={{ marginBottom: "-0.5rem" }}>
                            <h6 className="ms-2"> {data.title}</h6>
                          </div>
                        </div>
                      </div>
                    </>
                    // )}
                    // </>
                  ))}
                </div>
              </div>
            </div>
          </div>
        <ul className="d-flex space-y-20">
          {Menu.map((val, i) => (
            <li key={i}>
              <Link to={val.link} className="color_black">
                {val.title}
              </Link>
            </li>
          ))}
          <div className="space-y-20">
            {/* <div className="header__search in_mobile w-full">
              <input type="text" placeholder="Search" />
              <button className="header__result">
                <i className="ri-search-line" />
              </button>
            </div> */}

            <div className="btn btn-grad btn-sm">
              {isConnected ? `${address.slice(0, 5)}... ${address.slice(-5)}` : "Connect wallet"}
            </div>
          </div>

     
        </ul>
      </div>
    </div>
  );
}

export default MobileMenu;
